module.exports = __webpack_public_path__ + "img/addClass.24f364aa.png";